import React from "react";
import { CardProps } from "../../../types";
import "./Card.css";

const Card: React.FC<CardProps> = ({ children, className = "", style = {}, onClick, ...props }) => {
  return (
    <div
      className={`common-card ${className}`}
      style={style}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
